export const features = {
  advancedSettings: 'advancedSettings',
}

const flags = {
  [features.advancedSettings]: true,
}

export const featureEnabled = (flag) => {
  return flags[flag]
}
